// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification-item{width:240px;padding:10px 15px !important}`, "",{"version":3,"sources":["webpack://./src/components/functional/Notifications/NotificationItem/NotificationItem.scss"],"names":[],"mappings":"AAAA,mBACI,WAAA,CACA,4BAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
